<template>
  <div class="stats-strip">
    <div class="stats-strip-inner">
      <div class="stat-item">
        <div class="stat-num">{{ t('stats.timeValue') }}</div>
        <div class="stat-label">{{ t('stats.timeLabel') }}</div>
      </div>
      <div class="stat-item">
        <div class="stat-num">{{ t('stats.historyValue') }}</div>
        <div class="stat-label">{{ t('stats.historyLabel') }}</div>
      </div>
      <div class="stat-item">
        <div class="stat-num">{{ t('stats.dataPointsValue') }}</div>
        <div class="stat-label">{{ t('stats.dataPointsLabel') }}</div>
      </div>
      <div class="stat-item">
        <div class="stat-num">{{ t('stats.accuracyValue') }}</div>
        <div class="stat-label">{{ t('stats.accuracyLabel') }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
</script>
